import { Injectable } from '@angular/core';
import { IAppState } from '@myStore/app.state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  ECompaniesViewActions,
  GetCompaniesFailure,
  GetCompaniesRequest,
  GetCompaniesSuccess,
  GetGraduatesFailure,
  GetGraduatesRequest,
  GetGraduatesSuccess,
  GetVacanciesFailure,
  GetVacanciesRequest,
  GetVacanciesSuccess,
} from '@myStore/companies/view/companies-view.actions';
import { CompaniesViewService } from '@services/companies/view/companies-view.service';
import { ICompany, IGraduates, IVacancies } from '@interfaces/ICompany';

@Injectable()
export class CompaniesViewEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _toastr: ToastrService,
    private _companiesViewService: CompaniesViewService
  ) {}

  $getCompanies = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetCompaniesRequest>(ECompaniesViewActions.GetCompaniesRequest),
        switchMap(action => {
          return this._companiesViewService
            .getCompanies(action.options?.qparams)
            .pipe(
              map((companies: ICompany) => {
                this._store.dispatch(new GetCompaniesSuccess(companies));
              }),
              catchError(err => {
                this._toastr.error(
                  `При запросе коспаний возникла ошибка (get)`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(new GetCompaniesFailure(err));
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $getGraduates = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetGraduatesRequest>(ECompaniesViewActions.GetGraduatesRequest),
        switchMap(action => {
          return this._companiesViewService
            .getGraduates(action.options?.qparams)
            .pipe(
              map((graduates: IGraduates) => {
                this._store.dispatch(new GetGraduatesSuccess(graduates));
              }),
              catchError(err => {
                this._toastr.error(
                  `При запросе выпускников возникла ошибка (get)`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(new GetGraduatesFailure(err));
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $getVacancies = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetVacanciesRequest>(ECompaniesViewActions.GetVacanciesRequest),
        switchMap(action => {
          return this._companiesViewService
            .getVacancies(action.options?.qparams)
            .pipe(
              map((vacancies: IVacancies) => {
                this._store.dispatch(new GetVacanciesSuccess(vacancies));
              }),
              catchError(err => {
                this._toastr.error(
                  `При запросе вакансий возникла ошибка (get)`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(new GetVacanciesFailure(err));
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );
}
